import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import axios from 'axios';
import { BrdsqlService } from '../../services/brdsql.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-sugarcaneperhour',
  templateUrl: './sugarcaneperhour.component.html',
  styleUrls: ['./sugarcaneperhour.component.css']
})
export class SugarcaneperhourComponent implements OnInit {

  @ViewChild('tb_canehour') tb_canehour: ElementRef;
  todaydate = '';//new Date().toLocaleString('th-TH', { year: "numeric", month: "long", day: "2-digit", hour: "2-digit", minute: "2-digit" });
  yearLabelTh: string | any;
  qsetup: any = [];

  constructor(private brdsql: BrdsqlService,) { }

  date2: Date;
  ngOnInit(): void {
    //this.date2 = new Date();
    this.reload();
    this.getYearActive();
  }
  loading = [false, false];
  reload() {
    this.todaydate = new Date().toLocaleString('th-TH', { year: "numeric", month: "long", day: "2-digit", hour: "2-digit", minute: "2-digit" });
    if (!this.date2) { //เช็คdate2 ว่ามีค่าหรือไม่
      let d1 = new Date()
      let targetTime = new Date();
      targetTime.setHours(18, 0, 0, 0);// ตัวอย่างเวลาที่ต้องการเปรียบเทียบ (18:00)
      if (d1.getTime() >= targetTime.getTime()) { // เปรียบเทียบเวลาปัจจุบันกับเวลาที่ต้องการ
        d1.setDate(d1.getDate() + 1);// เพิ่ม 1 วัน
      }
      this.date2 = d1;
    }
    //else this.date2

    let dateE = this.date2.toLocaleString('sv-SE', { year: "numeric", month: "2-digit", day: "2-digit" });
    this.Loadcaneperhour(dateE);
    //this.Loadshowboardcar(dateE);
    console.log('dateE:', dateE);
  }

  datacarSum: {};
  datacar1: any[];
  datacar2: any[];
  datacar3: any[];
  datacar4: any[];
  datacar5: any[];
  datacar6: any[];
  datacar8: any[];
  Loadshowboardcar(date: string) {
    //let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[dbQBRD].[dbo].[v_qtypemonitor]&w=1=1'
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/qtype_monitor?yearid=6768&date=' + date
    this.loading[0] = true;
    axios.get(url)
      .then(res => {
        this.loading[0] = false;
        let data = res.data;
        this.datacar1 = data.filter((el: any) => el.qtype == 1);
        this.datacar2 = data.filter((el: any) => el.qtype == 2);
        this.datacar3 = data.filter((el: any) => el.qtype == 3);
        this.datacar4 = data.filter((el: any) => el.qtype == 4);
        this.datacar5 = data.filter((el: any) => el.qtype == 5);
        this.datacar6 = data.filter((el: any) => el.qtype == 6);
        this.datacar8 = data.filter((el: any) => el.qtype == 8);
        let dataAr = { wgtnet: 0, caneperdate: 0, pccane: 0 }

        data.forEach(entry => {
          dataAr.wgtnet += entry.wgtnet || 0;
          dataAr.caneperdate += entry.caneperdate || 0;
          dataAr.pccane = (dataAr.wgtnet / dataAr.caneperdate) * 100 || 0;
        });
        this.datacarSum = dataAr;
        //console.log('datadw:', dataAr);
      })
      .catch(err => { throw err });
  }

  caneperhour = [];
  sumdata: {}
  Loadcaneperhour(date: string) {
    let date_e = date
    //let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbbrr/select_s_f_w_0?s=*&f=[dbPayment].[dbo].[cpc_canehour]&w=REPORTDATE='${date_e}' ORDER BY REPORTDATE DESC`
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbbrr/cpc_canehour?REPORTDATE=${date_e}`
    this.loading[0] = true;
    axios.get(url)
      .then(res => {
        this.loading[0] = false;
        let data = res.data;
        this.caneperhour = data.filter((el: any) => el.canehour != 'sum');
        this.sumdata = data.filter((el: any) => el.canehour == 'sum')[0];
        //console.log('sumdata:', dataAr);
      })
      .catch(err => { throw err });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.caneperhour = [];
    this.datacar1 = null;
    this.datacar2 = null;
    this.datacar3 = null;
    this.datacar4 = null;
    this.datacar5 = null;
    this.datacar6 = null;
    this.datacar8 = null;
  }

  async getYearActive() {
    await this.brdsql.getYearActive()
      .subscribe((res: any) => {
        // console.log('res: ', res)
        if (res) {
          this.qsetup = res.recordset[0];
          this.yearLabelTh = this.qsetup.yearThUsed;
          this.yearLabelTh = this.addSlashInMiddle(this.yearLabelTh);
        }
      })
  }

  addSlashInMiddle = (input: string): string => {
    if (input.length !== 4) {
      throw new Error("Input must be a string with exactly 4 characters");
    }
    const part1 = input.slice(0, 2); // ตัดสองตัวแรก เช่น "67"
    const part2 = input.slice(2);    // ตัดสองตัวหลัง เช่น "68"
    return `${part1}/${part2}`; // รวมเป็น "67/68"
  };


  ExportExcel() {
    let date0 = new Date().toLocaleString('sv-SE', { year: "numeric", month: "2-digit", day: "2-digit" });
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.tb_canehour.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'data_');
    console.log('date0:', date0);
    /* save to file */
    XLSX.writeFile(wb, `ยอดอ้อยรายชั่วโมง_${date0}.xlsx`);
  }

}
